/* eslint-disable jsx-a11y/anchor-is-valid */
import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {
    withActionScheduler,
    type ITimeout,
    type WithActionSchedulerProps,
    type WithoutActionScheduler,
} from "@khanacademy/wonder-blocks-timing";
import {doNotTranslate} from "@khan/i18n";
import {Errors, KAError} from "@khan/logging";
import {staticUrl} from "@khan/urls";

import PageRoot from "#app-shell-package/page-root.tsx";
import $ from "#jquery/jquery.ts";

import AboutHeader from "./about-header.tsx";
import AboutNav from "./about-nav.tsx";
import {withStrings} from "./locales/our-interns/load-strings.tsx";

import adiAlt from "./intern-headshots/adigollamudi-alt.jpg";
import adiHeadshot from "./intern-headshots/adigollamudi.jpg";
import krithikaV1 from "./intern-headshots/krithikav1.jpg";
import krithikaV2 from "./intern-headshots/krithikav2.jpg";

type OwnProps = Empty;
type Props = OwnProps & WithActionSchedulerProps;

class OurInterns extends React.Component<Props> {
    // @ts-expect-error - TS2564 - Property 'defaultSearchBarPosition' has no initializer and is not definitely assigned in the constructor.
    defaultSearchBarPosition: number;
    $spacer: any;

    componentDidMount() {
        this.initLayout();
        this.initSearch();
        this.initInterns();
    }

    initInterns(): void {
        const defaultSearchBarPosition = this.defaultSearchBarPosition;
        if (defaultSearchBarPosition === undefined) {
            throw new KAError(
                "TeamPage.init must be called before initInterns",
                Errors.Internal,
            );
        }

        // Filter interns by year
        $(".nav-year-item").click(function (this: HTMLElement, e: Event) {
            e.preventDefault();
            // eslint-disable-next-line no-invalid-this
            $(this).siblings("li").removeClass("active");
            // eslint-disable-next-line no-invalid-this
            $(this).addClass("active");
            // eslint-disable-next-line no-invalid-this
            const filterFor = $(this).attr("id").split("-")[1];
            $(".team-card").each(function (i, elem) {
                const classToShow = "intern-" + filterFor;
                if (filterFor === "all" || $(elem).hasClass(classToShow)) {
                    $(elem).show();
                } else {
                    $(elem).hide();
                }
            });
        });
    }

    initLayout() {
        const {schedule} = this.props;
        const $portraitContainer = $(".portrait-container");
        let unhoverTimeout: ITimeout | null | undefined = null;
        // Ensure bottom of the page has enough room to not cut off card info,
        // fade out portraits when any person is hovered
        $("#the-team .team-card").hover(
            function (this: HTMLElement) {
                // eslint-disable-next-line no-invalid-this
                const infoHeight = $(this).children(".card-info").height();
                const currentPadding = parseInt(
                    $(".portrait-container").css("padding-bottom"),
                );
                if (infoHeight > currentPadding) {
                    $(".portrait-container").css("padding-bottom", infoHeight);
                }
                $portraitContainer.addClass("over-team-card");
                if (unhoverTimeout != null) {
                    unhoverTimeout.clear();
                    unhoverTimeout = null;
                }
            },
            function () {
                // Don't remove the class right away because the user is
                // probably just moving the mouse from one card to another
                // and if we remove the class and add it again performace
                // suffers badly.
                if (unhoverTimeout != null) {
                    unhoverTimeout.clear();
                    unhoverTimeout = null;
                }
                unhoverTimeout = schedule.timeout(() => {
                    $portraitContainer.removeClass("over-team-card");
                }, 500);
            },
        );
    }

    initSearch() {
        this.defaultSearchBarPosition = $(".title-section").outerHeight();

        if ($(".title-section").length) {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            this.defaultSearchBarPosition += $(".title-section").offset().top;
        }

        const defaultSearchBarPosition = this.defaultSearchBarPosition;
        // Autofocus on search box when page loads.
        $("#employee-search-box").focus();

        // Search when the user types in the search box.
        $("#employee-search-box").on("input", function (this: HTMLElement) {
            // eslint-disable-next-line no-invalid-this
            const filterFor = $(this).val().toLowerCase();

            // Show all cards that contain the search phrase. Hide cards that
            // don't.
            const $cards = $(".team-card");
            const toShow: Array<Element> = [];
            $cards.each(function (i, elem) {
                const lowerCasedText = $(elem).text().toLowerCase();
                if (
                    filterFor === "" ||
                    lowerCasedText.indexOf(filterFor) >= 0
                ) {
                    toShow.push(elem);
                }
            });

            // Hide all of the cards, *force layout*, then show the ones we
            // want. We do this because otherwise Chrome has a bug in
            // conjunction with -webkit-column-count where the containers don't
            // shrink to the proper height and leave awkward gaps. This seems
            // to fix it. (Doing so resets the scroll position, but that's okay
            // because we're about to set it anyway.)
            $cards.css("display", "none");
            if (document.body) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                document.body.offsetHeight; // force layout
            }
            $(toShow).css("display", "");

            window.scrollTo(0, defaultSearchBarPosition);
        });
    }

    renderSearchBar: () => React.ReactNode = () => (
        <div className="employee-search">
            <input
                type="text"
                placeholder={t`Search for an intern...`}
                id="employee-search-box"
            />
        </div>
    );

    renderYearPane: () => React.ReactNode = () => (
        <nav className="navigation-by-year">
            <ul>
                <li className="nav-year-item active" id="filter-all">
                    <a href="#">{t`ALL`}</a>
                </li>
                <li className="nav-year-item" id="filter-2025">
                    <a href="#">{t`2025`}</a>
                </li>
                <li className="nav-year-item" id="filter-2024">
                    <a href="#">{t`2024`}</a>
                </li>
                <li className="nav-year-item" id="filter-2023">
                    <a href="#">{t`2023`}</a>
                </li>
                <li className="nav-year-item" id="filter-2022">
                    <a href="#">{t`2022`}</a>
                </li>
                <li className="nav-year-item" id="filter-2021">
                    <a href="#">{t`2021`}</a>
                </li>
                <li className="nav-year-item" id="filter-2020">
                    <a href="#">{t`2020`}</a>
                </li>
                <li className="nav-year-item" id="filter-2019">
                    <a href="#">{t`2019`}</a>
                </li>
                <li className="nav-year-item" id="filter-2018">
                    <a href="#">{t`2018`}</a>
                </li>
                <li className="nav-year-item" id="filter-2017">
                    <a href="#">{t`2017`}</a>
                </li>
                <li className="nav-year-item" id="filter-2016">
                    <a href="#">{t`2016`}</a>
                </li>
                <li className="nav-year-item" id="filter-2015">
                    <a href="#">{t`2015`}</a>
                </li>
                <li className="nav-year-item" id="filter-2014">
                    <a href="#">{t`2014`}</a>
                </li>
                <li className="nav-year-item" id="filter-2013">
                    <a href="#">{t`2013`}</a>
                </li>
                <li className="nav-year-item" id="filter-2012">
                    <a href="#">{t`2012`}</a>
                </li>
                <li className="nav-year-item" id="filter-2011">
                    <a href="#">{t`2011`}</a>
                </li>
            </ul>
        </nav>
    );

    // NOTE: Dear interns and others editing this section. For contact links,
    // only Github, LinkedIn, and KA profiles are allowed. Please do not link
    // to any other external sites. This also goes for any links within your
    // bio copy.
    renderInterns: () => React.ReactNode = () => (
        <div className="portrait-container">
            {/* Krithika's card */}
            <div className="team-card intern-2025">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`A headshot of Krithika in her graduation stole and cords standing in an archway`}
                        src={krithikaV1}
                    />
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt -- TODO: Address a11y error */}
                    <img
                        className="alternate"
                        alt={doNotTranslate`An image of Krithika wearing a white shirt and a red jacket in front of a sandy hill.`}
                        src={krithikaV2}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Krithika`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Krithika is a rising grad student pursuing her Masters in Computer Science at the University of Michigan. She’s excited to be returning to Khan Academy as a SWE Intern on the Data Infrastructure team. Outside of work/school, Krithika enjoys going on runs, playing the guitar, and watching ice hockey.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/vkrithika25/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Krithika's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/vkrithika25"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Krithika's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            {/* Adi's card */}
            <div className="team-card intern-2025">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Adi Smiling`}
                        src={adiHeadshot}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Adi piggy back riding a pig statue`}
                        src={adiAlt}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Adi`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Adi is a rising junior studying computer science at the University of Washington in Seattle. He is passionate about education access and tech development for social good. Adi is a Lil Uzi Vert enthusiast and enjoys dressing up for occasions that absolutely don’t require it.`}
                    </p>
                </div>
            </div>
            {/* Ben's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        alt={doNotTranslate`Ben smiling with a waterfront in the background.`}
                        src={staticUrl("/images/headshots/interns/benc.jpeg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ben`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Ben is an experienced educator, having taught Social Studies at Noble Schools in Chicago for almost ten years. In his free time, he enjoys reading, working out, playing soccer and tennis, and going to the movies with his wife. He is also an avid fan of Liverpool FC. He’s excited to contribute to the learning of students around the world through the work at Khan Academy`}
                    </p>
                </div>
            </div>
            {/* Chassity's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Chassity smiling on a cliffside hike.`}
                        src={staticUrl(
                            "/images/headshots/interns/chassity.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Chassity wearing a lemon-patterned top in a selfie.`}
                        src={staticUrl(
                            "/images/headshots/interns/chassity2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Chassity`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Chassity is a high school social studies teacher in Indianapolis. She is obsessed with teaching and learning, AP Human Geography, social justice, and the use of AI in education. Outside of her work, she loves traveling, reading, sewing, and her dog, Addie.`}
                    </p>
                </div>
            </div>
            {/* Hannah's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Hannah smiling in a forest with arms crossed.`}
                        src={staticUrl(
                            "/images/headshots/interns/hannahchorley1.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Hannah at the top of a mountain summit, arms raised victoriously.`}
                        src={staticUrl(
                            "/images/headshots/interns/hannahchorley2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Hannah`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Hannah is an English teacher, having taught in both Chicago, Illinois and Cape Town, South Africa. With a background in journalism and a passion for educational equity, Hannah loves to connect her students with real-word topics beyond their classroom walls. In her free time, she loves reading fantasy books, doodling, and camping. She is excited to help the ELA team launch their secondary curricula this summer!`}
                    </p>
                </div>
            </div>
            {/* Helena's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Helena smiling in a helicopter flying over a marsh.`}
                        src={staticUrl("/images/headshots/interns/helena.jpg")}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Helena smiling while sitting atop an ATV.`}
                        src={staticUrl(
                            "/images/headshots/interns/helena2.jpeg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Helena`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Helena is a field biologist turned science teacher. She is from Brasil and is now living in South Florida. Holding a master’s in environmental science, she is passionate about conservation education and empowering youth. She enjoys scuba diving, rock climbing, and hiking in different national parks.`}
                    </p>
                </div>
            </div>
            {/* Juliana's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        alt={doNotTranslate`Juliana, wearing a black shirt and smiling in a selfie.`}
                        src={staticUrl(
                            "/images/headshots/interns/julianadoherty.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Juliana`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Juliana is an experienced math educator, having taught math for 13 years including teaching in NYC, Boston, and Philadelphia. In her free time she loves playing with her two young children, reading thriller books, and going to the beach. She is incredibly excited to work with the math team at Khan Academy.`}
                    </p>
                </div>
            </div>
            {/* Sana's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        alt={doNotTranslate`Sana wearing graduation regalia and smiling, arm holding her graduation cap high.`}
                        src={staticUrl("/images/headshots/interns/sana.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sana`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Sana is a math teacher in LAUSD. As a first-generation, low-income student herself, she is passionate about equity and social justice in education. This summer, she is excited to work as a content intern on DEIB initiatives to make Khan Academy’s lessons more inclusive. In her free time, Sana loves to crochet, throw mugs on in her ceramics studio, and puzzle.`}
                    </p>
                </div>
            </div>
            {/* Anna's card */}
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`A headshot of Anna wearing a black knit beanie with one of those cute little poofs on it, in front of a snowy background.`}
                        src={staticUrl(
                            "/images/headshots/interns/annamistele.jpg",
                        )}
                    />
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt -- TODO: Address a11y error */}
                    <img
                        className="alternate"
                        alt={doNotTranslate`A photo of Anna in the kitchen, holding a bowl of snow and a spoon. One might guess, correctly, that she is about to eat the snow.`}
                        src={staticUrl(
                            "/images/headshots/interns/annamistele2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Anna`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Anna is studying computer science and education at Stanford University. She cares really deeply about democratizing education and is so excited to be working on the Learning Experience Math and Science team this summer! Anna loves improv, pickleball, and napping in sunny little areas.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/anna-mist/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Anna's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/aemandine"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Anna's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://www.khanacademy.org/profile/annamistele"
                            className="contact-ka"
                            aria-label={`${doNotTranslate`Anna's Khan Academy profile`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`A headshot of Anastasia in a grey puffer standing on a bridge with a mountain behind her.`}
                        src={staticUrl(
                            "/images/headshots/interns/anastasia_d1.jpg",
                        )}
                    />
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt -- TODO: Address a11y error */}
                    <img
                        className="alternate"
                        alt={doNotTranslate`An image of Anastasia wearing a purple sweater, holding up laptop against the Boston skyline.`}
                        src={staticUrl(
                            "/images/headshots/interns/anastasia_d2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Anastasia`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Anastasia is a rising junior at MIT. With a goal to achieve educational equity globally, she's excited to be a SWE Intern on the Teacher Experience team. Outside of school, Anastasia loves to play frisbee, climb, bike, and drink boba/coffee with friends.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/anastasia21112/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Anastasia's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/anastasia21112"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Anastasia's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`A headshot of Matt smiling in a navy oxford shirt against a gray background.`}
                        src={staticUrl(
                            "/images/headshots/interns/mattdembiczak.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`A scenic headshot of Matt smiling in sunglasses, taken in Central Park, NYC.`}
                        src={staticUrl(
                            "/images/headshots/interns/mattdembiczak-alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Matt`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Matt is studying Computer Science and Digital Arts & Media Design at Penn State University, and is interning on the Content Platform team remotely from Pittsburgh, PA. He is passionate about technology and interactive media, and is always keeping up with the lastest indie games. In his free time, he loves to cook, stay active, and play piano.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/mattdembiczak/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Matt's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/mojadem"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Matt's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Jason smiling while wearing winter apparel.`}
                        src={staticUrl(
                            "/images/headshots/interns/jasonli1.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Jason smiling with his thumbs up while a monkey rests on his shoudlers.`}
                        src={staticUrl(
                            "/images/headshots/interns/jasonli2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jason`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Jason is currently studying computer science and business at Western University. When Jason is not binging the latest Khan Academy videos, you can find him watching movies, traveling the world, or skiing. He is very excited to join the Districts team this summer!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/lijason02/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Jason's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/Jasspie"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Jason's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`A headshot of Krithika in a black coat standing at a wooden railing with trees behind her.`}
                        src={staticUrl(
                            "/images/headshots/interns/krithikav1.jpg",
                        )}
                    />
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt -- TODO: Address a11y error */}
                    <img
                        className="alternate"
                        alt={doNotTranslate`An image of Krithika wearing a white dress standing at a metal railing with a waterfall in the background.`}
                        src={staticUrl(
                            "/images/headshots/interns/krithikav2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Krithika`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Krithika is a rising senior at the University of Michigan majoring in computer science. She’s excited to be a SWE Intern on the Data Infrastructure team and is passionate about using technology to make resources like education and healthcare accessible to communities around the world. Outside of work/school, Krithika enjoys learning the guitar, playing volleyball and badminton, and watching the TV show FRIENDS.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/vkrithika25/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Krithika's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/vkrithika25"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Krithika's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        alt={doNotTranslate`A headshot of Fabiola`}
                        src={staticUrl("/images/headshots/interns/fabiola.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Fabiola`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Fabiola is interning on the Content Platform Team! Fabiola comes with a creative background pivoting into tech, beginning with her recent graduation at Ada's Developers Academy. Fabiola enjoys making art, hiking, and anything dog related.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/gonzalezfabiola"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Fabiola's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/fabi01a"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Fabiola's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        alt={doNotTranslate`A headshot of Theffy`}
                        src={staticUrl(
                            "/images/headshots/interns/theffy_reyes.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Elena`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Elena, aka Theffy, is interning on the Guided Learning team!. She studied Information System at UNNE in Corrientes, Argentina, and currently lives near Washington,DC. Theffy loves learning both human and programming languages. She's excited to work on projects that improve accessible education.When she's not coding, she enjoys hiking, travelling to new places, and reading horror/mistery books.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/elena-estefan%C3%ADa-reyes-992864140/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Theffy's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/Theffy92"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Theffy's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2024">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`A headshot of Carter wearing a beige collared shirt in front of a Christmas tree`}
                        src={staticUrl(
                            "/images/headshots/interns/carter_moore_3.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Carter wearing a beige, navy, and white sweater with autumn leaves in the background`}
                        src={staticUrl(
                            "/images/headshots/interns/carter_moore_4b.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Carter`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Carter is a 4th-year Computer Science student at the University of Waterloo. After an awesome internship experience at Khan Academy in Summer 2023, Carter is back for a second software engineering internship! He looks forward to continuing his work on Khanmigo.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/carterjmoore/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Carter's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/carterjmoore"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Carter's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2023">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Marian standing amd smiling while wearing a white cardigan and brown camisole.`}
                        src={staticUrl(
                            "/images/headshots/interns/marian_2.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Marian looking up at a giraffe at the zoo.`}
                        src={staticUrl(
                            "/images/headshots/interns/marian_1.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Marian`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Marian is a rising senior at the University of Toronto studying Computer Science. You can either find her curled up with Philz and a good book, or climbing at the local bouldering gym. She is stoked to be working at Khan Academy this summer on the Frontend Infrastructure team.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/marianmwang"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Marian's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2023">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Maggie doing a peace sign at a brunch place.`}
                        src={staticUrl(
                            "/images/headshots/interns/maggie-2.jpg",
                        )}
                    />
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt -- TODO: Address a11y error */}
                    <img
                        className="alternate"
                        alt={doNotTranslate`Maggie is taking a picture with her dog Bochi on their birthdays`}
                        src={staticUrl(
                            "/images/headshots/interns/maggie-1.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Maggie`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Maggie is a rising senior at UC San Diego, studying computer science with an interest in business management. She loves going on long walks with her dog Bochi and trying new foods. Some of her current favorite dishes are Ethiopian Yebeg tibs and fufu. She aspires to be someone who can make a positive impact on the world through software and is ecstatic to be working on the Content Platform team this summer!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/maggie-liu-26aa53228"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Maggie's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/maggieliu123"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Maggie's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2023">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Emily in a plaid shirt with the Duquesne Incline in the background.`}
                        src={staticUrl(
                            "/images/headshots/interns/emilyamspoker.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Emily wearing a white and orange argyle sweater while standing on a ladder in an apple tree.`}
                        src={staticUrl(
                            "/images/headshots/interns/emilyamspoker-alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Emily`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Emily is a rising junior studying computer science and human-computer interaction at Carnegie Mellon University. She is interested in working towards making education more accessible through technology. In her spare time, she likes to do Taekwondo, play video games, and read. This summer, she's super excited to join the Learning Components team here at Khan Academy!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/emily-amspoker-52944b18a"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Emily's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/eamspoker"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Emily's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2023">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Divya wearing a floral blouse, standing in front of the Chicago River.`}
                        src={staticUrl(
                            "/images/headshots/interns/divya_koya_1.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Divya in midair after jumping on a sandy beach.`}
                        src={staticUrl(
                            "/images/headshots/interns/divya_koya_2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Divya`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Divya is an undergrad at the University of Illinois Urbana-Champaign, where she studies computer science and doodles all over her lecture notes. In her free time, she can be found reading, dancing, at the gym, or drinking tea. She's very excited to be at Khan Academy this summer on the Data Infra team!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/divya-koya-51953b1ab/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Divya's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/scarletdiv0922"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Divya's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2023">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Carter wearing a grey sweater standing on a balcony overlooking the CN Tower`}
                        src={staticUrl(
                            "/images/headshots/interns/carter_moore_1.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Carter sitting posed on some stairs, wearing a burgandy sweater over a white collared shirt`}
                        src={staticUrl(
                            "/images/headshots/interns/carter_moore_2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Carter`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Carter hails from the small Canadian province of New Brunswick and is currently studying Computer Science at the University of Waterloo. He enjoys dancing to hiphop and kpop, and playing video games, and watching anime. Carter is excited to help develop the future of educational AI while working on Khanmigo.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/carterjmoore/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Carter's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/carterjmoore"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Carter's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2022">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Lara smiling and wearing a sparkly, wavy dress`}
                        src={staticUrl(
                            "/images/headshots/interns/Lara_King_primary.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Lara posing on front of the Khan Academy sign wearing a Khan Academy blue t-shirt`}
                        src={staticUrl(
                            "/images/headshots/interns/Lara_King_alternate.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Lara`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Lara is a rising senior majoring in computer science and minoring in business at the University of Michigan. She enjoys sailing, playing tennis, writing, and traveling. She has used Khan Academy extensively as a student in New Zealand and in the US! She is excited and honored to intern at Khan Academy this summer.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/lara-0-k"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Lara's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/lk101101"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Lara's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2022">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Ishani smiling from ear to ear.`}
                        src={staticUrl("/images/headshots/interns/ishani2.jpg")}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Ishani with the HackDavis mascot!`}
                        src={staticUrl(
                            "/images/headshots/interns/ishani-alternate2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ishani`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Ishani is a rising senior at UC Davis and is back for her second internship at KA! She is excited to be a part of the Districts team this year. She is passionate about fitness, cooking, and helping out her community.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/ishani-pandya"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Ishani's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/ishanip24"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Ishani's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2022">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Madeleine standing in a vineyard at sunset.`}
                        src={staticUrl(
                            "/images/headshots/interns/madeleinecharity.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Madeleine sitting on a rock at the beach.`}
                        src={staticUrl(
                            "/images/headshots/interns/madeleinecharityalt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Madeleine`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Madeleine is an undergraduate studying computer science at Stanford. She is passionate about educational equity and making quality education accessible with technology. In her free time, Madeleine enjoys reading, exploring nature, and trying new foods.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/madeleine-charity-23484713a"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Madeleine's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/madeleine-charity"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Madeleine's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2022">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Ying smiling with a bowl of ramen in front of him.`}
                        src={staticUrl("/images/headshots/interns/ying1.jpg")}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Ying looking happy and surprised with redwood trees in the background.`}
                        src={staticUrl("/images/headshots/interns/ying2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ying`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Ying is a rising senior at UC Berkeley, where he is pursuing a major in computer science and a minor in education. Beyond school, his interests include psychology and human-centered design. He also loves to cook, watch basketball, and explore nature in his free time.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/yinglin2/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Ying's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/yinglin33"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Ying's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2022">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Angel smiling with a sun hat in Puerto Rico.`}
                        src={staticUrl(
                            "/images/headshots/interns/angel_smiling.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Angel laughing in Puerto Rico.`}
                        src={staticUrl(
                            "/images/headshots/interns/angel_laughing.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Angel`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Angel is a rising junior at Caltech studying computer science. She plays on the Caltech volleyball team and also enjoys playing tennis, singing, cooking/baking, and hanging out with friends. She's very excited to be working at Khan Academy!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/angel-wang-822567187/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Angel's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2022">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Peter doing a peace sign behind some dumplings.`}
                        src={staticUrl("/images/headshots/interns/peterli.png")}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Peter looking away from the camera at a dessert shop.`}
                        src={staticUrl(
                            "/images/headshots/interns/peterli-alt.png",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Peter`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Peter is an undergrad at Brown University, where he studies computer science and performs in a lion dance troupe. He also likes design, computer graphics, and fantasy books. He's very excited to be here!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/peter-li-194b4a14a"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Peter's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/petersli"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Peter's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2021">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Gina in front of some greenery, smiling.`}
                        src={staticUrl(
                            "/images/headshots/interns/ginaKhanIMG1.JPG",
                        )}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Gina in front of some greenery, laughing.`}
                        src={staticUrl(
                            "/images/headshots/interns/ginaKhanIMG2.JPG",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Gina`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Gina is a senior at Stanford where she studies computer science and creative writing. She loves word games, exploring the outdoors, and trying out new vegetarian recipes. She's stoked to be joining such a vibrant community of people at Khan Academy.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/gina-valderrama-2021"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Gina's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/Gina-Valderrama"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Gina's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2021">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Ishani wearing a floral blouse and smiling wide!`}
                        src={staticUrl("/images/headshots/interns/ishani.jpg")}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Animated Ishani`}
                        src={staticUrl(
                            "/images/headshots/interns/ishani-alternate.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ishani`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Ishani is a rising junior studying Computer Science at UC Davis. She is eager to learn as much as she can during her internship! Aside from work, she loves fitness, healthifying food (featuring several failed attempts), and dancing.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://github.com/ishanip24"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Ishani's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2021">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt={doNotTranslate`Hunter next to a cliff on the Big Sur`}
                        src={staticUrl("/images/headshots/interns/hunter1.jpg")}
                    />
                    <img
                        className="alternate"
                        alt={doNotTranslate`Hunter carrying sister`}
                        src={staticUrl("/images/headshots/interns/hunter2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Hunter`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Hunter is a rising senior studying mechanical engineering at UPenn. He loves climbing and talks about it too much and wants to learn about coastal foraging. He’s really excited about the opportunity to learn and contribute at Khan Academy!`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://github.com/Hunterzhaoliu"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Hunter's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2021">
                <div className="card-photo">
                    <img
                        alt={doNotTranslate`Carlos, sporting tussled black hair, standing outside wearing dark-rimmed glasses, and smiling`}
                        src={staticUrl("/images/headshots/interns/carlos.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Carlos`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Carlos is a rising junior studying computer science at the University of Alabama at Birmingham. When not coding, he loves to play competitive first-person shooter games, attempt to cook 5-star meals, and watch all kinds of YouTube videos.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://github.com/RivasCVA"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Carlos's GitHub page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2021">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/chase3.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Chase`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Chase is back for his third internship! After deciding to take a gap year from UC Irvine, he is excited for the opportunity to return to Khan Academy.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/ChaseC99"
                            className="contact-github"
                            target="_blank"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/ChaseCarnaroli/"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2020">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/wendyboeker.jpeg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/wendyboeker2.jpeg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Wendy`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Wendy is a rising senior at Georgetown University studying Computer Science, Economics, and Japanese. Outside of work, she can usually be found singing and jamming out on the ukulele, drawing, reading comics, playing tennis, or trying to climb the ranked ladder in League.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/wboeker/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Wendy's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/wboeker"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Wendy's Github page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2020">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/lucia.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Lucia`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Lucia is a rising senior at Stanford University, majoring in Computer Science and minoring in Math. She is passionate about educational equity and applications of technology to the political/policy space. In her spare time, she enjoys reading, discovering new music, and drinking coffee.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://www.linkedin.com/in/zlucia/"
                            className="contact-home"
                            aria-label={`${doNotTranslate`Lucia's LinkedIn page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                        <a
                            href="https://github.com/zlucia"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Lucia's Github page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2020">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/matheus.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Matheus`}</h2>
                    <h3>{doNotTranslate`Business Intelligence Intern`}</h3>
                    <p>
                        {doNotTranslate`Matheus is one of the few born in Brazil having access to high-quality education, and he’ll try his best to change that reality. He’s studying Business at the University of São Paulo, and he’s very interested in the growing start-up ecosystem in his home city. In his free time, he enjoys cooking, playing games, watching movies, and listening to music.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2020">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/thomas2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Thomas`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Thomas is a rising junior studying Computer Science at Caltech. He is a devoted student-athlete on the Caltech varsity swim team. In his free time, he likes to drink coffee, explore new foods, and pick up new programming languages and technologies.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://github.com/thomasbarrett"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Thomas's Github page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2020">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/chase2.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/chase2-alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Chase`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Chase is a rising senior at UC Irvine studying Computer Science. He interned at Khan Academy last year where he wrote code and developed a passion for bread baking. Chase also still enjoys spending time out in nature, hammocking, hiking, and playing beach volleyball.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/ChaseC99"
                            className="contact-github"
                            target="_blank"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/ChaseCarnaroli/"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2020">
                <div className="card-photo">
                    <img
                        className="normal"
                        aria-hidden={true}
                        alt=""
                        src={staticUrl("/images/headshots/interns/stanley.JPG")}
                    />
                    <img
                        className="alternate"
                        aria-hidden={true}
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/stanley-alt.JPG",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Stanley`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Stanley is a rising senior at Brown University studying Computer Science and Music. He’s passionate about the ethical responsibilities of tech and computing in society. In his free time, he enjoys drinking coffee, playing video games, and playing piano.`}
                    </p>
                    <p className="contact-links">
                        <a
                            href="https://github.com/yipstanley"
                            className="contact-github"
                            aria-label={`${doNotTranslate`Stanley's Github page`} ${doNotTranslate`Opens in a new tab`}`}
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        aria-hidden={true}
                        alt=""
                        src={staticUrl("/images/headshots/interns/nisha2.jpeg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Nisha`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Back for another round! Nisha graduated from UC San Diego with a major in Math-CS. She likes metal model kits and puzzles.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        className="normal"
                        aria-hidden={true}
                        alt=""
                        src={staticUrl("/images/headshots/interns/laker.jpg")}
                    />
                    <img
                        className="alternate"
                        aria-hidden={true}
                        alt=""
                        src={staticUrl("/images/headshots/interns/laker2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Laker`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Laker got hooked on math because he needed it to program video games. Now he’s helping expand Khan Academy’s college math courses. He also enjoys morning hikes, foreign languages, pickup basketball, and all kinds of cheese.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/Arongil"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/cyrus.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Cyrus`}</h2>
                    <h3>{doNotTranslate`Legal Intern`}</h3>
                    <p>
                        {doNotTranslate`Cyrus is a law student at Santa Clara University. He enjoys traveling, soccer, playing the guitar, live music, and most importantly — coffee.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/cyrus-b-57846b3b"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/shayna.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/shayna2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Shayna`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Shayna is a rising junior studying Computer Science and Human Rights at UC Berkeley; she's passionate about education, inequality, and Trader Joe's. She can usually be found buying books, listening to podcasts, or looking for aesthetically pleasing cafes!`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/shaynak"
                            className="contact-github"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jaclyn.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jaclyn`}</h2>
                    <h3>{doNotTranslate`Product Design Intern`}</h3>
                    <p>
                        {doNotTranslate`Jaclyn is a rising junior at Carnegie Mellon University, where she studies design and human-computer interaction. Her interests include coffee, national parks, design ethics, and using the WhatFont Chrome extension on everything.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/salman.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Salman`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Salman is a SWE intern who, like many students his age, grew up on Khan Academy. He is a rising senior at Rutgers University studying Computer Engineering. His favorite activities include playing basketball, squash, volleyball, and Switch games.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/salman-omer/"
                            className="contact-home"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/kumail.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Kumail`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Kumail is a rising senior studying Computer Science at McMaster University. He enjoys reading books, playing table tennis & board games, and watching math videos on YouTube in his free time.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/kumailn"
                            className="contact-github"
                            target="_blank"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/kumail"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/matthew.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/matthew_alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Matthew`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Matthew is a rising senior at Stanford University majoring in Computer Science and Public Policy with specializations in AI and education, respectively. He's not really sure what this "spare time" thing is, but he'd like to try it sometime.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/matthewds/"
                            className="contact-home"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/matthewkol186"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/chase.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/chase-alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Chase`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Chase is a rising junior studying Computer Science at the University of California, Irvine. He first learned how to code on Khan Academy in middle school and has been passionate about Computer Science ever since. When he’s not coding, Chase enjoys spending time out in nature, hammocking, hiking, and playing beach volleyball.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/chasecarnaroli/"
                            className="contact-home"
                            target="_blank"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/ChaseC99"
                            className="contact-github"
                            target="_blank"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/ChaseCarnaroli/"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/yashshah.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Yash`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Yash is a rising senior studying Computing Engineering at Rutgers University. In his spare time, he enjoys traveling the world, learning about technology, and spending too much time on Netflix and YouTube.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/shahhyash/"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/cathy.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Cathy`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Cathy is a rising junior studying Software Engineering at the University of Waterloo. In her spare time, she enjoys developing for social good, traveling, and buying things she doesn't need.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/cathy-m-wang/"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/alexandershah.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Alexander`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Alexander is a rising junior studying Computer Science at the University of Waterloo. In his spare time, he likes to watch dramas and drink flavored water.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://ca.linkedin.com/in/zandershah"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2019">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/yan.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Yan`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Yan is a rising junior studying Computer Science at the University of Waterloo. During his spare time, he enjoys watching cheesy dramas, playing video games, and making terrible coffee.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/dasani1.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/dasani2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Dasani`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Dasani is a rising senior at Case Western Reserve University and studies Computer Science and Philosophy. Having access to good educational resources changed her life and she hopes to use her skills in technology to extend that privilege. In her spare time Dasani can be found hiking, crafting, eating icecream or bingewatching Netflix.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/dasani-m/"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/stephanie.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Stephanie`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Stephanie is a rising senior Stanford University, where she studies computer science and education. In her spare time, she likes to sing, read, and spend time at the beach.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/stephanie-campa-852b46123/"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/kelsey.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/kelsey-alternate.jpg",
                        )}
                    />
                </div>

                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Kelsey`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Kelsey studied computer science at MIT, where she also dabbled in teaching middle and high school students how to program. Despite her lack of height, she enjoys playing volleyball, and although she is a terrible singer, she can somewhat play the clarinet.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/kelseyc18"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        aria-hidden={true}
                        alt=""
                        src={staticUrl("/images/headshots/interns/nisha.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Nisha`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Nisha studies mathematics and computer science at UC San Diego. She's the president of Triton XR, UCSD's virtual and augmented reality club, and her hobbies include playing video games and traveling.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jennie.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jennie`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Jennie studied computer science and statistics at UC Berkeley and will continue studying computer science at Stanford in the fall. When she has time, she likes to do puzzles and try out various kinds of arts and crafts.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/mary.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/mary-alternate.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Mary`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Mary is a rising senior at MIT studying computer science and math. She plays ultimate frisbee and basketball, and she also enjoys playing guitar. Mary can often be found drinking lots of coffee or boba.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/mzhong9723"
                            className="contact-home"
                            target="_blank"
                        />
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/mzhong9723"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/yeva1.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/yeva2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Yeva`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Yeva studies computer science at the University of Waterloo. Her hobbies include badminton, hiking, and spending days at a time obsessively trying to master new games she picks up.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/yeva-yu"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/anesu1.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Anesu`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Anesu is a Computer Science student at Duke University. In his spare time he enjoys watching and playing basketball, watching TV shows, and reading books`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/ioana3.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ioana`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Yes, that is also me two photos over.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/ioanacrant"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/samuel.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Samuel`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Samuel is a California native & graduate from Cal State Monterey Bay. His thirst for adventure is unrivaled. When he isn't backpacking across seas or trying to save the world, he can be found strumming away on his guitar.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/samuelrey"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/Nada_resized.png",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/Nada2_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Nada`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Nada studied Computer Science and Engineering at the German university in Cairo. She persued her Master's degree in Computer Science from Johannes Kepler University in Linz. When Nada is not coding or studying, she loves hanging out, board games, video games and coloring.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.linkedin.com/in/nada-abdelhamid-56740542/"
                            className="contact-home"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/ioana.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/ioana2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ioana`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Ioana is studying Combinatorics and Optimization at the University of Waterloo. She loves developing for social good, online shopping, and poutine.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/ioanacrant"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2018 intern-2017">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/sophie.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/sophie-alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sophie`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Sophie studies computer science and linguistics at MIT. Her goal is to use computer science to improve education and natural language understanding. She loves puzzles, crosswords, languages, reading, paper folding, and public transit systems.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/wishdasher"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/slim_resized.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/slim-alt_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Slim`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Slim, a rising senior at Northwestern, loves sea creatures and functional programming. In her spare time, she enjoys playing Oregon Trail for Windows XP.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/sliminality"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/audrey.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Audrey`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Audrey is a rising junior at MIT studying Computer Science. She loves to dance, play pool, and jam with her more musically talented friends.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/anesu2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Anesu`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Anesu is a Computer Science student at Duke University. In his spare time he enjoys watching and playing basketball, watching TV shows, and reading books`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/yejia.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Yejia`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Yejia studies (and teaches) Computer Science at UC Berkeley. She has an interest in education and social equality, and outside of school, enjoys cooking, working out, and watching waaaay too many vlogs.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/kasrakoushan.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/kasrakoushan2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Kasra`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Kasra is a computer science student at the University of Pennsylvania interning on the backend team at Khan Academy. He grew up in Toronto and is a big fan of math, pomegranates, and hip hop. He loves using Khan Academy to learn about things like human physiology and finance.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/kasrakoushan"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/veena.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Veena`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Veena is studying Mathematics and Education Studies at Yale University. She is interested in data science and the ways that it can be used to improve education.  Outside of class, she enjoys painting, playing table tennis, reading, and going for walks.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/emilyling.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/emilyling2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Emily`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Emily is a rising senior at Stanford studying computer science. She loves exploring new places, taking pictures, singing, hiking, and adding more and more books to her never-ending reading list.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2017">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/gustavo.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Gustavo`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Gustavo grew up in Brazil, where he found his passion for playing the guitar, listening to rap, and working for education. He's currently studying Computer Science at Stanford.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/samanthadoran.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Samantha`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Samantha is an alumni of the Recurse Center. She enjoys programming, getting lost, and reading up on old hardware.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/samanthadoran"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/joy.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/joy-2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Joy`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Meet Joy. Joy graduated from University of Pennsylvania and Tsinghua University, studying developmental psychology. She is passionate about education and personalized learning. She enjoys painting, acting, designing and table tennis. She is also a big fan of board games.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/davidpowell.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`David`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`David is an information Engineering student at the University of Cambridge. He is excited to be working with so many people enthusiastic to change the future of education. Outside of work, he enjoys playing tennis, reading, as well as the occasional card game.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/davidmpowell"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/nick.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Nick`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Nick is a CS student at Cal Poly SLO. He can usually be found programming, playing the cello, or jamming out to Taylor Swift.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/nickfrostatx"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/shadaj.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Shadaj`}</h2>
                    <h3>{doNotTranslate`Software Engineering Intern`}</h3>
                    <p>
                        {doNotTranslate`Shadaj is a high school student in the Bay Area who loves coding. When he isn't doing that, he loves to play the sitar and challenge friends to races in Mario Kart.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/debora.png")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/debora-hover.png",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Débora`}</h2>
                    <h3>
                        {doNotTranslate`International Market Development Intern`}
                    </h3>
                    <p>
                        {doNotTranslate`Débora is supporting Khan Academy's growth in her home region, Latin America. She came to the Bay Area to do an MBA at UC Berkeley with the goal of learning business skills that she could apply to create social  impact at scale, and also to enjoy California's forward-thinking and outdoorsy lifestyle.`}
                    </p>
                    {/* {# The below is a quick-fix to ensure the search can pull up Debora without using an accent #} */}
                    <p style={{display: "none"}}>{doNotTranslate`Debora`}</p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/becca.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Becca`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Becca is a native Philadelphian studying History at Claremont McKenna College. When she's not over-annotating primary sources, Becca runs a branch of a nonprofit that provides hip-hop dance classes to youth without access to engaging after school activities. She also loves hiking, saag paneer, and The Beatles.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/reberhardt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ryan`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Ryan loves doing things with other people: programming, playing music, shooting photography, cooking, hiking, and more! He loves spreading his passions through education and is excited to be working on the infrastructure team at Khan Academy.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/diedra.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Diedra`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Diedra is a former artist that's excited to be helping develop the future of education. In their spare time they enjoy chasing pigeons and reading comics.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/abdul.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Abdul`}</h2>
                    <h3>{doNotTranslate`Mobile Development Intern`}</h3>
                    <p>
                        {doNotTranslate`Abdul studies CS at UC Berkeley. In high school, he enjoyed learning on Khan Academy much more than he did in school, so he would like every student with a smartphone to be able to bring Khan Academy to their classroom. `}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/alex_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Alex`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Alex is a Computer Science student at MIT working on a Master's degree focusing in machine learning. Outside of that, he enjoys DJing and producing electronic music.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/thomas.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/thomas-hover_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Thomas`}</h2>
                    <h3>{doNotTranslate`Data Science Intern`}</h3>
                    <p>
                        {doNotTranslate`Thomas is a PhD student at North Carolina State University where he researches ways to integrate artificial intelligence and data into educational technologies. He’s thrilled to be working with so many bright folks at Khan Academy who are dedicated to improving education for all.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/thomaswp/"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/george.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/george2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`George`}</h2>
                    <h3>{doNotTranslate`Mobile Development Intern`}</h3>
                    <p>
                        {doNotTranslate`George believes that connecting progressive pedagogy enabled by technology with social movements for economic and educational justice can—and <em>will</em>—profoundly transform education for the better.`}
                    </p>
                    <p>
                        {doNotTranslate`George is a student of Cognitive Science and Education in the`}{" "}
                        {doNotTranslate`Critical Education Policy Studies`}{" "}
                        {doNotTranslate`group at Swarthmore College.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/shiranka.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Shiranka`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Shiranka is a Software Engineering student from the University of Waterloo.  He loves reading fantasy novels, especially those written by Brandon Sanderson, and his goal is to write code that is an absolute delight to work with.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/kejia.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Kejia`}</h2>
                    <h3>{doNotTranslate`Product Design Intern`}</h3>
                    <p>
                        {doNotTranslate`Kejia is working on designing the SAT experience this spring. When she’s not working, she’s typing on her blog while petting her cats at the same time. She graduated from University of Michigan and Fudan University and has helped design fridges and dashboards.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/evy_resized.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/evy2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Evy`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Evy is a Computer Science student at the University of Waterloo. She loves developing technology for social good and talking about education and other social issues. When she's not coding or hanging out with friends in her awesome communities, she's probably singing or conducting choral music.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/karl.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/karl.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Karl`}</h2>
                    <h3>{doNotTranslate`Data Science Intern`}</h3>
                    <p>
                        {doNotTranslate`Karl is a fourth year student from the University of New South Wales in Australia. He enjoys skiing, playing video games, scuba diving, travelling, referring to himself in the third person, and performing various other standard human activities that don't implicate him as an undercover alien from another planet.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/willfarmer.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Will`}</h2>
                    <h3>{doNotTranslate`Data Science Intern`}</h3>
                    <p>
                        {doNotTranslate`Will is a data science intern from the University of Colorado, Boulder. He will be graduating in the fall with a major in Applied Math and a minor in Computer Science. When not working on his latest math problem, Will likes to wander around forests and experience the outdoors, with the occasional climb involved. Will is excited to be out in California for the summer and is still perplexed by the fantastic Californian trees.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/ian.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ian`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Ian has found himself a slice of ed-tech heaven at Khan Academy. At MIT his research is in artificial echolocation for the blind, but you may also catch him on a run along the Charles river or engaged in some armchair urban planning. He's saving up for a trip to Antarctica to meet the emperor penguins.`}
                    </p>

                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="http://github.com/idreyn"
                            className="contact-github"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2016">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/paige.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/paige-over.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Paige`}</h2>
                    <h3>{doNotTranslate`Content Intern`}</h3>
                    <p>
                        {doNotTranslate`Paige is a rising junior at UC Berkeley majoring in linguistics. At Khan Academy she works as a content intern for Team Grammar, and she can't wait to see what great things will come out of her summer here at KA! Apart from school and work, she is busy exploring her newfound love of cats, watching Suits, and eating lots of cereal. Her favorite day of the week is Bread Day.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/meredith.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/meredith2.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Meredith`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Meredith just graduated from Stanford but is going back to get a Master's degree. She is a born explorer, traveler, eater, and adrenaline junkie. She loves watching TV, and she is particularly fond of Doctor Who, Parks and Rec, Friday Night Lights, and Avatar: The Last Airbender.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/vishesh.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Vishesh`}</h2>
                    <h3>{doNotTranslate`Data Science Intern`}</h3>
                    <p>
                        {doNotTranslate`Vishesh loves learning and is interested in understanding and improving the systems around us! When he's not learning/building things, he can be found meditating, running outside, playing music (jazz, mostly), or giving free hugs to people.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/juliana.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/juliana2_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Juliana`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Juliana rhymes with banana is incredibly excited to be interning on the web frontend team at Khan Academy! In her free time she loves playing boardgames, singing while playing her ukulele, and being outdoors. This fall she will be returning to Stanford to finish her master's degree in computer science.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/davidwang.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`David`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`David studies computer science at Stanford, after dabbling in psychology, philosophy, and linguistics.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2016 intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/wchargin_chewie.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Willow`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Willow is a computer science major at Carnegie Mellon. She enjoys trying to learn as much math and computer science as is humanly possible, and digging tunnels with her dog at the beach.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://github.com/wchargin"
                            className="contact-github"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/sherman.png")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/sherman2.png",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sherman`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Sherman is studying Computer Science at Stanford University and working on the Mobile! team this summer. He's broadly interested in applying technology to healthcare and education and plays basketball, piano, and multiple episodes of TV shows when he's not working on learning something new.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/chelseavoss_resized.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/chelseavoss_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Chelsea`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Chelsea studies computer science as a master's student at MIT. She enjoys learning the world's writing systems, inventing new writing systems, exploring the Curry-Howard isomorphism, reading sci-fi short stories, learning, teaching, and working to make the world a better place.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/anastassia.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/anastassia2_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Anastassia`}</h2>
                    <h3>{doNotTranslate`Data Science Intern`}</h3>
                    <p>
                        {doNotTranslate`Anastassia is a rising senior at Carnegie Mellon, majoring in Computer Science and minoring in Language Technologies. She loves math, education and brains, so she is super excited to be joining Khan Academy!! In her free time, she enjoys hiking, getting lost in new cities and taking lots of pictures.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/mopewa.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Mopewa`}</h2>
                    <h3>{doNotTranslate`Mobile Development Intern`}</h3>
                    <p>
                        {doNotTranslate`Mopewa is a rising senior with a double major in computer science and robotics at Carnegie Mellon University. She enjoys watching TV, drinking tea, knitting, reading, and other activities that don't require much movement.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/hannah.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Hannah`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Hannah is a rising senior studying computer science at Harvard College. She fell in love with Khan Academy while designing a CS curriculum for middle school students. Her favorite activities include biking and baking.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/sam.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sam`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Sam is a student at UC Berkeley working on Khan Academy's article system. He does a lot of learning and teaching and hopes do to even more of it at Khan. Sam loves shared meals, adventure, and looking at bodies of water.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            target="_blank"
                            href="https://github.com/samlau95"
                            className="contact-github"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/alexirpan_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Alex Irpan`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Alex is a rising senior at UC Berkeley, doing a CS major and a kind-of math major, depending on if he ever finishes the major requirements or not. He works on the infrastructure team, plays card games, and reads web fiction.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/phillip.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Phillip`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Phillip is a computer engineering student at the University of Texas at Austin. He enjoys programming, math, and Star Trek. He also has interests in data science and artificial intelligence.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/monica.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Monica`}</h2>
                    <h3>
                        {doNotTranslate`International Market Development Intern`}
                    </h3>
                    <p>
                        {doNotTranslate`Monica is an aspiring dashboard wizard for the International Market Development team. When she's not at Khan Academy, maxing out Google Sheets' capabilities or mapping out K-12 curricula around the world, you can find her at Stanford, pursuing her MBA and Master of Education.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/neel.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/neel2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Neel`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Neel, a member of Harvard's Class of 2018, enjoys teaching computer science, watching baseball, cracking jokes, saying 'yo,' and trying to avoid falling off his skateboard.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2015">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/shannon_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Shannon`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Shannon studies Computer Science at Harvard College, and is interning on the web frontend team at Khan Academy. She loves dancing, traveling, and drawing animals, and has been excited about and dabbling in teaching and education for years!`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/shyan.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Shyan`}</h2>
                    <h3>{doNotTranslate`Product Design Intern`}</h3>
                    <p>
                        {doNotTranslate`Shyan is a recent graduate of UC Berkeley, where he studied Anthropology, Political Economy, and Environmental Design.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/shane.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/shane2_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Shane`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Shane has started a tutoring business and done research in education psychology. Now he's working with Khan Academy to provide a life-changing education for anyone, anywhere, forever. When he's not learning, building things, or pondering, he's playing outside.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/alexrodrigues.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Alex`}</h2>
                    <h3>{doNotTranslate`Developer - Computer Science`}</h3>
                    <p>
                        {doNotTranslate`Alex is a student at the University of Waterloo studying Mechatronics engineering. He is passionate about FIRST robotics and working on making education more efficient. He also shows a surprising propensity for body surfing.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/madeleine.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Madeleine`}</h2>
                    <h3>{doNotTranslate`Video Content Producer`}</h3>
                    <p>
                        {doNotTranslate`Madeleine studies Film and International Relations at the University of Southern California and is interning for Khan Academy as a video content producer. When she's not in school, she enjoys jungle trekking, writing music, making dumb films with friends, and helping people learn new and exciting things!`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/vivek.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/vivek2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Vivek`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Vivek believes in bringing a world-class education for anyone, anywhere; he's working on Khan Academy's iPad app so you can learn math even while sitting on your couch. When he's not reading, building things, or leading the various organization he's a part of, he studies Computer Science at Rutgers University.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl("/images/headshots/davidk.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/davidk2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`David`}</h2>
                    <h3>{doNotTranslate`Content Production Intern`}</h3>
                    <p>
                        {doNotTranslate`David is a senior at Princeton majoring in Everything, with excursions into computer science, creative writing, and ancient literature. When confined to bed by an illness in high school, David discovered e-learning and has since spent countless hours teaching and learning online. He can also be found shooting portraits, directing films, and thinking deep thoughts.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/jessie.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/jessie2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jessie`}</h2>
                    <h3>{doNotTranslate`Software Developer Intern`}</h3>
                    <p>
                        {doNotTranslate`Jessie studies applied math and computer science at Stanford. She'd like to save the world - or at least help someone (anyone!) learn. She is working on the user experience team this summer, and also enjoys running, exploring, and wandering the great outdoors.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/jonathan.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/jonathan2_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jonathan`}</h2>
                    <h3>{doNotTranslate`Software Developer Intern`}</h3>
                    <p>
                        {doNotTranslate`Jonathan has just graduated from UC Berkeley majoring in Computer Science and Business Administration and interned on the internationalization team at Khan Academy, where he had the privilege of bringing education to people around the world. He devotes himself to his Christian community at Gracepoint Fellowship Church. He likes music, photography and talking about life. He dislikes talking about himself in third person.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/jseng"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/ilan.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/ilan2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ilan`}</h2>
                    <h3>{doNotTranslate`Software Developer Intern`}</h3>
                    <p>
                        {doNotTranslate`You are Ilan, a rising senior from Stanford University majoring in Physics and coterming in Computer Science. You enjoy hiking, rocking out on the piano and guitar, playing Ultimate and ping pong, and sleeping. You can sing any Disney song on command and your spirit animal is a grizzly bear. You are an avid Giants fan, you love <i>Harry Potter</i>, and you know more than anyone should about The Who.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/benkraft.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ben`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Ben studies math with a side of physics and computer science at MIT.  When he's not busy learning, teaching, or writing education-related software, he enjoys hiking, folding origami, and making smoothies.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/benkraft"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/miles.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Miles`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Miles studies a computer science and stuff at MIT. When he isn't coding he likes to unicycle, fly drones, and code more. He hopes to one day be able to do all three at once. He is excited to help make the user experience of Khan Academy even more awesome!`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/charlie.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Charlie`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Charlie is a computer science major at Princeton University with a passion for both learning and teaching. His research interests focus on machine learning, and he's previously interned at Microsoft and Facebook. This summer, he'll be working as part of the Content Tools team to improve Khan Academy's exercise experience.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jared.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jared`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Jared wants to change the world, so he joined Khan Academy to intern for the summer. He enjoys singing, hiking, making things, and deep conversation. He is helping improve the experience for teachers and parents on Khan Academy.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/jaredly"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/kevin.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Kevin`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Kevin studies computer science at the University of Illinois and enjoys using technology to improve life in creative ways. He is excited to make Khan Academy's user experience more awesome as part of the Content Tools team this summer.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/peter.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/peter2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Peter`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Meet Peter. Peter is a level 14 Neuromancer at UC Berkeley. He somewhat enjoys reading, writing, running, ice cream, robots, kittens, artificial intelligence, natural stupidity, economics, Freakonomics, swimming, biking, Hunter S. Thompson, oranges, coding, philosophy, fancy sodas, and long lists. Peter works on Data, where he regularly refers to himself in the third person.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        className="normal"
                        src={staticUrl(
                            "/images/headshots/interns/elizabeth-new.jpg",
                        )}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/elizabeth-alt.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Elizabeth`}</h2>
                    <h3>{doNotTranslate`Product Design Intern`}</h3>
                    <p>
                        {doNotTranslate`Elizabeth studies computer science at Cal with a focus in design. She loves high fashion, ampersands, and sushi. This summer, she's working on designing exercises for the iPad app!`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/kasra.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/kasra-2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Kasra`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Kasra studies computer science at the University of Toronto. He is working on the Khan Academy iPad app this summer.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/john.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`John`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`John likes making software and infecting others with his love for Computer Science. He is very excited to harness the powers of the coffee bean in order to make Khan Academy's search tool amazing.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/colin.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Colin`}</h2>
                    <h3>{doNotTranslate`Data Science Intern`}</h3>

                    <p>
                        {doNotTranslate`Colin is a biologist turned analyst who loves using data to tackle challenging problems, loves singing, and loves eating beets.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/justin.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Justin`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Justin works on the Content Tools team to help content creators write questions. He goes to the University of Waterloo and likes writing Vimscript (for some reason).`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/theo.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Theo`}</h2>
                    <h3>{doNotTranslate`Computer Science Intern`}</h3>

                    <p>
                        {doNotTranslate`Theo is a student from the University of Waterloo, where he studies Combinatorics and Computer Science.  He's working to improve subtitles and internationalization by hacking in Python at Khan Academy.  He also enjoys functional programming, vim, and Khan Academy's board game night.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2014">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/richard.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Richard`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Richard likes the winters in California more than the winters at the University of Waterloo, where he is a third-year student (though converting to Fahrenheit is difficult). He hopes to make Khan Academy even bigger while on the growth team.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/tal.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl("/images/headshots/interns/tal-alt.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Tal`}</h2>
                    <h3>{doNotTranslate`Teaching Fellow`}</h3>
                    <p>
                        {doNotTranslate`Tal is a lover of learning. How cliche. But seriously, one time, he underwent a surgical operation to have his feet webbed just to see if he could swim faster! But seriously, that's not true.`}
                    </p>
                    <p>
                        {doNotTranslate`Tal taught high school math in Philadelphia before moving out west to beautiful California in order to obtain a Ph.D. in Civil Engineering. For the foreseeable future, he will divide his time evenly doing the following: research in a lab, playing outside, and helping teachers effectively implement Khan Academy in their classrooms.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/taltul"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/suney2.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Suney`}</h2>
                    <h3>{doNotTranslate`Teaching Fellow`}</h3>
                    <p>
                        {doNotTranslate`As a teaching fellow, Suney supports the Educational Partnerships team at Khan Academy.  Suney shares her Khan Academy experiences with teachers and helps to support them as they start their Khan Academy journeys.`}
                    </p>
                    <p>
                        {doNotTranslate`Suney has been a teacher for 15 years. She is currently at Eastside College Preparatory School where she has fully implemented Khan Academy into her math curriculum.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/ben5.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ben`}</h2>
                    <h3>{doNotTranslate`Analytics Intern`}</h3>

                    <p>
                        {doNotTranslate`Ben wants to help bring education research online. He's a Chicagoan with a keen interest in learning, statistics, and sandwiches.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/tommy.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Tommy`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Tommy wishes to help increase the reach and impact of Khan Academy this fall. He is a native of Toronto who craves new experiences through learning, art, food, and adventure. He studies Software Engineering at the University of Waterloo and has previously interned at Twitter and VMware.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/leif.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Leif`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Leif loves learning! He also enjoys overcast weather, Chicken McNuggets, and fireworks. He's working on the Computer Science team.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/sophia.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sophia`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Sophia will be working on the CS team. She studies Computer Science at Stanford University and interned previously at Google and Palantir. She cares about using programming to make the world better -- she also enjoys sports and playing guitar.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/brie.jpg")}
                    />
                </div>

                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Brie`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Brie's mission is to design and develop experiences that bring happiness to people's lives. Brie's work at Khan Academy fulfills this mission because it helps empower others to learn, among the greatest forms of happiness.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/sbirch_resized.jpg",
                        )}
                    />
                </div>

                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sam`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Sam will be working on the learning interface and will be a senior at Brown University in the Fall. In his free time he enjoys cooking, biking, and drinking good tea. He's excited to spend his first summer in San Francisco.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/julia.jpg")}
                    />
                </div>

                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Julia`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Julia loves building things - both virtual and physical - and going on adventures! In her spare time, she is most likely exploring the outdoors, playing soccer, or eating fruit. `}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/damon.jpg")}
                    />
                </div>

                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Damon`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`The pinnacle nerd, Damon enjoys coding and video games (League of Legends and, less frequently now, Super Smash Bros. Melee). In his other time, you might find him playing frisbee or screaming furiously at the LSU Tigers or New Orleans Saints through the TV. He is studying Computer Science at MIT and will be working on the Growth team.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/dbieber.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`David`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`David Bieber enjoys mathematics, puzzles, and tennis, and he's a big fan of online education. He likes using programming to simplify life and figure things out, and he generally enjoys making things like games and puns. He spends his time thinking about thought, how fortunate he's been to have had such amazing teachers his whole life, and how to tell a good story.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jake.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jake`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Jake likes to build things and dream up ideas about the future. Besides his passion for programming, he enjoys music, board games, and running. He is working on the Interactive Content team to help content creators make exercises.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/sitan.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sitan`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Sitan is excited to work with the Analytics team this summer to design models for better understanding how people learn. He's a second-year math and compsci concentrator at Harvard College and enjoys piano, singing, and food.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/annie.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Annie`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>{doNotTranslate`Annie`}</p>
                    <p>
                        {doNotTranslate`When Annie isn't battling the forces of darkness with her D20s, she collects novelty socks. She is deeply passionate about puzzle solving and education and is eager to help make content management more user friendly this summer.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/mattdr.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Matt`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Matt loves making things. He just can't help it. He's spending the summer helping students identify what skills they should learn and better master those skills-vicariously, of course, through the system he's making.`}
                    </p>
                    <p>
                        {doNotTranslate`He's a Computer Science major at Rice University and has a deep, abiding love for learning, discovery, and building tools that help real people solve real problems. In other words, he's right where he belongs.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/rob.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/rob_smile.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Robert`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Robert is working on data analysis and visualization to make drawing insights a pleasure. He has passion for highly efficient and beautiful programs. He definitely spends too much time practicing ballroom dancing.`}
                    </p>
                    <p>
                        {doNotTranslate`Previously he interned at an investment bank which he helped move to a web-oriented architecture. He is currently a student at Imperial College London.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/aatash.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Aatash`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Aatash really believes in the idea that schooling shouldn't interfere with your education. It's why he is so excited to be helping Khan Academy reinvent learning.`}
                    </p>
                    <p>
                        {doNotTranslate`Aatash is an Electrical Engineering/Computer Science major at UC Berkeley. He's an avid basketball fan, and is always down for a 1-on-1 challenge. `}{" "}
                        {doNotTranslate`LeBron?`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jocelyn.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jocelyn`}</h2>
                    <h3>{doNotTranslate`Coach Reports Intern`}</h3>

                    <p>
                        {doNotTranslate`Jocelyn helps teachers trick students into learning.`}
                    </p>
                    <p>
                        {doNotTranslate`Jocelyn is studying Software Engineering at the University of Waterloo and has previously interned at a major Canadian fruit company, where she made the web faster.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/eliana_resized.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Eliana`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Eliana wants to make a teaching system so adaptive it can love you. They're a sci-fi reading nomad who write poetry in Python and climb hella mountains. Right now, they're a PhD student at UT Austin studying machine learning.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/cbhl.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/cbhl-box.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Michael`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Michael has a passion for good food and board games. He was previously an intern at Google and Facebook before being recruited by University of Waterloo Software Engineering classmate David.`}
                    </p>
                    <p className="contact-links">
                        {/* eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error */}
                        <a
                            href="https://www.khanacademy.org/profile/thenewme91"
                            className="contact-ka"
                            target="_blank"
                        />
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/tabitha.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Tabitha`}</h2>
                    <h3>{doNotTranslate`Graphic Design Intern`}</h3>

                    <p>
                        {doNotTranslate`Tabitha loves designing things so that they're accessible and fun to use. In her free time she loves learning about people, reading angsty literature, traveling, doodling, and eating cheesecake. She studies at RISD and Brown University and has previously interned at Apple and Konami.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2013 intern-2012">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/drew.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/drew-red-hair_resized.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Drew`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Drew is committed to developing tools that will help students share their knowledge with one another. He's worked on the software behind the KA community, email subscriptions, and translations.`}
                    </p>
                    <p>
                        {doNotTranslate`Drew is also an avid learner himself as a rising senior at Gunn High School. Prior to joining Khan Academy, he built mobile apps as an intern at Sony Ericsson. He's also a runner and a cellist.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2012 intern-2011">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/omar.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Omar`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Omar makes useful things that work. He started working on exercises way back in high school; he's been hooked on the vision ever since.`}
                    </p>
                    <p>
                        {doNotTranslate`In his free time, depending on when you ask, he might be a student at Stanford, a Thiel Fellow, or something completely different. He likes puns, Pok&eacute;mon games, history, and prime-numbered phones.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012 intern-2011">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/alpert.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Sophie`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>
                    <p>
                        {doNotTranslate`Sophie does her best to be everywhere at once and tries to fix problems wherever they pop up.`}
                    </p>
                    <p>
                        {doNotTranslate`When she's not working on things for Khan Academy, Sophie studies at Carnegie Mellon, where she's double-majoring in computer science and math.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2011 intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/david.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`David`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`David is a human being currently living on Earth. He was born after the Big Bang and before the heat death of the universe.`}
                    </p>
                    <p>
                        {doNotTranslate`David has also interned twice at Khan Academy and twice at Google.`}
                    </p>
                    <p>
                        {doNotTranslate`David regrets that he was not also named "Ben".`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jamiew.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jamie`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Jamie works with John to build the infrastructure for the computer science curriculum.`}
                    </p>
                    <p>
                        {doNotTranslate`Jamie was previously an intern at Facebook before being recruited by University of Waterloo Software Engineering classmate and programming contest teammate David.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        className="normal"
                        alt=""
                        src={staticUrl("/images/headshots/interns/josh.jpg")}
                    />
                    <img
                        className="alternate"
                        alt=""
                        src={staticUrl(
                            "/images/headshots/interns/josh_gandalf.jpg",
                        )}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Josh`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Josh is helping to collect more data on how people use Khan Academy so we can see how changes we make to the site affect what users do on it. He's also helping to use the data we collect to improve users' experiences while visiting the site.`}
                    </p>
                    <p>
                        {doNotTranslate`Josh is a Computer Science major (class of 2015) at Carnegie Mellon University.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/ankit.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Ankit`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Ankit loves to create new things. At Khan Academy, he is working on building up the community.`}
                    </p>
                    <p>
                        {doNotTranslate`He is currently doing a Masters in Computer Science at Virginia Tech, specializing in human computer interaction. Previously, he has participated twice in the Google Summer of Code program.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/emily.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Emily`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Emily is a Computer Science and Math major in the University of Rochester class of 2015. When not found hunched over her computer installing a Linux distro or learning an obscure programming language, she also enjoys bike rides, cooking, and playing video games.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/arun.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Arun`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Arun builds tools to make your exercise experience better. He is studying electrical engineering and computer science at MIT. He spent some time at Google, Intel and Procter & Gamble, as well as two social enterprises in India. He loves music and plays many different instruments.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/mark.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Mark`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Carved from the marbled cliffs of Elysium by the roaring surf below, Mark prefers his sandwiches open-faced. He works on exercises.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/leah.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Leah`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Leah is a computer science major at MIT in the class of 2013. She's working on improving coach reports at Khan Academy. She's had internships at Google and Rapleaf and enjoys softball, ice hockey, rock climbing, board games, and traveling.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jessica.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jessica`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Jessica eats tons of candy and teaches compooter science at Khan Academy!`}
                    </p>
                    <p>
                        {doNotTranslate`She is a senior at Brown University, where her favorite things are baking pies and making silly skits about programming.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/mary.png")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Mary`}</h2>
                    <h3>{doNotTranslate`Graphic Design Intern`}</h3>

                    <p>
                        {doNotTranslate`Mary is the design intern at Khan Academy, and currently attends the Rhode Island School of Design (conveniently shortened to RISD; pronounced "riz-dee"), located in Providence, Rhode Island (which is 3% larger at low tide). In her free time, she likes to design custom lettering, make books, and pump iron.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/dylan.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Dylan`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Dylan is spending the summer on Khan Academy's App Engine team helping to make the site faster and more reliable for everyone.`}
                    </p>
                    <p>
                        {doNotTranslate`He will graduate in 2013 with a B.S. in Computer Science from UCLA. Prior to Khan Academy he worked at the UCLA Center for Embedded Networked Sensing.`}
                    </p>
                </div>
            </div>
            <div className="team-card intern-2012">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jamiea.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jamie`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`When he's not hacking on cool stuff at Khan Academy, working on his thesis in Cognitive Science at UCSD, or helping to create thisCourse.com, Jamie loves to travel. He has slept overnight in a temple in Taiwan, in a monastery in Austria, in a cave on the Acropolis in Athens, on a staircase, on top of a volcano, on the roof of a train station, in a garbage bin, in a playground in Hiroshima, and in numerous closets.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2011">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/julian.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Julian`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Julian was a Fall 2011 intern who worked on exercises, Sandcastle, and Gandalf. He's had internships at Facebook and Arista Networks and really likes salsa dancing.`}
                    </p>
                </div>
            </div>

            <div className="team-card intern-2011">
                <div className="card-photo">
                    <img
                        alt=""
                        src={staticUrl("/images/headshots/interns/jeff.jpg")}
                    />
                </div>
                <div className="card-info">
                    <h2 className="pulls">{doNotTranslate`Jeff`}</h2>
                    <h3>{doNotTranslate`Software Engineer Intern`}</h3>

                    <p>
                        {doNotTranslate`Jeff spent the summer helping build Khan Academy's exercise framework and working with its community of open-source developers. Jeff obsesses over Zelda and Digimon, is one of the few left-handed color-blind redheads, and studied Computer Science and Math at Wesleyan University. Khan Academy lent him his first Mac, and he now works at Apple.`}
                    </p>
                </div>
            </div>
        </div>
    );

    render(): React.ReactNode {
        return (
            <PageRoot settings={{title: t`About Our Interns`}}>
                <div className="about-page">
                    <AboutHeader pageheadline={t`Meet Our Interns.`} />
                    <AboutNav aboutSelection="our-interns" />
                    <div id="the-team">
                        {this.renderSearchBar()}
                        <div>
                            {this.renderYearPane()}
                            {this.renderInterns()}
                        </div>
                    </div>
                </div>
            </PageRoot>
        );
    }
}

type ExportProps = WithoutActionScheduler<
    JSX.LibraryManagedAttributes<
        typeof OurInterns,
        React.ComponentProps<typeof OurInterns>
    >
>;
export default withStrings(
    withActionScheduler(OurInterns) as React.ComponentType<ExportProps>,
);
